import { RegisterOptions, useFormContext } from "react-hook-form";
import { Radio } from "@chakra-ui/react";
import { Stack } from "@chakra-ui/react";
import { BaseFormControl } from "./abstractions/base-form-control";
import { RadioGroup } from "@chakra-ui/react";

interface FormBooleanProps {
  name: string;
  label: string;
  rules?: RegisterOptions;
  isReadOnly?: boolean;
}

export function FormBoolean({ name, label, rules, isReadOnly }: FormBooleanProps) {
  const { register, watch } = useFormContext();
  const value = watch(name);
  const options = [
    {
      label: "Yes",
      value: "true",
    },
    {
      label: "No",
      value: "false",
    },
  ];

  return (
    <BaseFormControl
      name={name}
      label={label}
      isRequired={!!rules?.required}
      isDisabled={!!rules?.disabled}
      isReadOnly={isReadOnly}
    >
      <RadioGroup value={value?.toString()}>
        <Stack direction="row" spacing={4} alignItems="center">
          {options?.map(option => (
            <Radio
              key={option.label}
              value={option.value}
              isReadOnly={isReadOnly}
              {...register(name, rules)}
            >
              {option.label}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
    </BaseFormControl>
  );
}
